import React from "react";

const ModelDetails = ({ model }) => {
  return (
    <div style={styles.container}>
      <strong>Model: {model.name || "N/A"}</strong>
      {Array.isArray(model.generations) && model.generations.length > 0 ? (
        model.generations.map((gen) => (
          <div key={gen.id_car_generation} style={styles.generation}>
            <em>Generacija: {gen.name || "N/A"}</em>
          </div>
        ))
      ) : (
        <div style={styles.noGenerations}>Nema generacija</div>
      )}
    </div>
  );
};

export default ModelDetails;

const styles = {
  container: {
    marginLeft: 10,
    marginBottom: 12,
  },
  generation: {
    marginLeft: 20,
    marginBottom: 8,
  },
  noGenerations: {
    marginLeft: 20,
    fontStyle: "italic",
  },
};
